import Command from './_Command';
import { ApryseSDK } from '../../pdf/ApryseSDK';

export default class StateCommandButton extends Command {
    constructor(
        public readonly StateName: string,
        public readonly Path: string,
        public readonly IconColor?: string,
        public readonly IconBackgroundColor?: string,
        public readonly Enabled = true,
    ) {
        super({
            Enabled,
            StateName,
            Path,
            IconColor,
            IconBackgroundColor,
            Key: StateName,
            Callback: () => {
                ApryseSDK.setToolMode(this.StateName);
            },
        });
    }
}
